import React from "react";

interface BlogCardProps {
  image: string;
  title: string;
  excerpt: string;
  tags: string[];
  published_date: string;
  read_time: string;
  category: string;
}

const tagColorMap: Record<string, string> = {
  "UI Design": "bg-[#E6F4EA] text-green-800",
  "Graphic Design": "bg-[#FEECEC] text-red-700",
  "Design": "bg-[#E8F0FE] text-blue-700",
  Travel: "bg-[#FFF3E0] text-orange-700",
};

const BlogCard: React.FC<BlogCardProps> = ({
  image,
  title,
  excerpt,
  tags,
  published_date,
  read_time,
  category,
}) => {
  return (
    <div className="w-full max-w-md  overflow-hidden bg-white ">
      <div
        className="h-60 bg-cover bg-center rounded-xl"
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className="p-5 space-y-2 bg-[#f9f9f9] rounded-b-xl">
        {/* Tags */}
        <div className="flex flex-wrap gap-2">
          {tags.map((tag, i) => (
            <span
              key={i}
              className={`text-xs px-3 py-1 rounded-full font-medium ${
                tagColorMap[tag] || "bg-gray-100 text-gray-700"
              }`}
            >
              {tag}
            </span>
          ))}
        </div>

        {/* Date + read time */}
        <p className="text-sm text-gray-500">
          {published_date} — {read_time}
        </p>

        {/* Title */}
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>

        {/* Excerpt */}
        <p className="text-sm text-gray-600">{excerpt}</p>
      </div>
    </div>
  );
};

export default BlogCard;
